import { Icon, Tooltip } from '@mairistem/composants';
import { Feature, Menu } from '@mairistem/module';
import _ from 'lodash';
import { MENUS } from '@/constants';
import { showTooltips } from '@/utils';
import { useRegieStore, useRegisseurStore } from '@/zustand';
import {
  CycleContextProvider,
  FactureContextProvider,
  LoadingContextProvider,
  ModeReglementContextProvider,
} from '../Context';
import PrelevementRouter from './PrelevementsRouter';

// Icône stable (hors rendu) : @mairistem/module ré-enregistre le menu, en fin de liste, dès que
// l'icône change de référence — ce qui arriverait à chaque re-rendu dû aux stores.
const ICON = showTooltips ? (
  <Tooltip
    trigger={<Icon name="level down alternate" />}
    message="Gestion des factures prélevées"
    position="right center"
  />
) : (
  <Icon name="level down alternate" />
);

const MenuPrelevements = () => {
  const disabledMenus = useRegieStore((state) => state.disabledMenus);
  const regisseur = useRegisseurStore((state) => state.regisseur);

  return (
    <Menu
      code={MENUS.MENU_PRELEVEMENTS}
      name="Gestion des factures prélevées"
      icon={ICON}
      path="/factures-prelevees"
      // @ts-expect-error
      visible={!_.isNil(regisseur) && disabledMenus?.prelevements !== true}
    >
      <Feature>
        <Feature.Content>
          <LoadingContextProvider>
            <ModeReglementContextProvider autoload="régie">
              <FactureContextProvider type="prelevee">
                <FactureContextProvider type="rejet">
                  <CycleContextProvider avecPrelevement>
                    <PrelevementRouter />
                  </CycleContextProvider>
                </FactureContextProvider>
              </FactureContextProvider>
            </ModeReglementContextProvider>
          </LoadingContextProvider>
        </Feature.Content>
      </Feature>
    </Menu>
  );
};

export default MenuPrelevements;
